<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="editor-field">
        <div>
          <!-- Hiển thị đơn vị tiền tệ -->
          <div class="config-name mb-4">
            <span style="line-height: 1.5;">{{'hien_thi_don_vi_tien_te' | translate}}</span>
            <nz-switch [(ngModel)]="config['currency']['currency_check']"
              (ngModelChange)="updateConfig()"></nz-switch>
          </div>

          <app-text-format-config
                  [device]="device"
                  [objectChoosing]="objectChoosing"
                  [class]="class"
                  [config]="config"
                  [staticdata]="staticdata"
                  [textContentClass]="class['total-price-bill__content']"
                  [textWrapperClass]="class['total-price-bill__wrapper']"
                  >
          </app-text-format-config>
          <div class="field-row">
            <div class="config-font" style="margin-top:20px">
              <!-- Khoảng cách chữ -->
              <div>
                <div class="config-name">
                   <p>{{'khoang_cach_chu' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50"
                    [ngModel]="class['total-price-bill__content']['letter-spacing'] | vhnumber"
                    (ngModelChange)="class['total-price-bill__content']['letter-spacing'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['total-price-bill__content']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['total-price-bill__content']['letter-spacing'] = $event +'px'"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <!-- Khoảng cách dòng -->
              <div>
                <div class="config-name">
                   <p>{{'khoang_cach_dong' | translate}}</p>
                  <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                    [(ngModel)]="this.class['total-price-bill__content']['line-height']"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="this.class['total-price-bill__content']['line-height']"
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing" [isBlock]="false">
          </app-hide-show-config>
        </div>
      </li>
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <div>
            <!-- Hiển thị đơn vị tiền tệ -->
            <div class="config-name mb-4">
              <span style="line-height: 1.5;">{{'hien_thi_don_vi_tien_te' | translate}}</span>
              <nz-switch [(ngModel)]="config['currency']['currency_check']"
                (ngModelChange)="updateConfig()"></nz-switch>
            </div>

            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    [staticdata]="staticdata"
                    [textContentClass]="class['total-price-bill__content']"
                    [textWrapperClass]="class['total-price-bill__wrapper']"
                    >
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['total-price-bill__content']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['total-price-bill__content']['letter-spacing'] = $event +'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['total-price-bill__content']['letter-spacing'] | vhnumber"
                        (ngModelChange)="class['total-price-bill__content']['letter-spacing'] = $event +'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="this.class['total-price-bill__content']['line-height']"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['total-price-bill__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình khoảng đệm-->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['total-price-bill__content']" [paddingConfigs]="[
          { type: 'top' },
          { type: 'bottom' },
          { type: 'left' },
          { type: 'right' },
        ]">
        </app-padding-config>
      </li>
      <!-- Cấu hình viền-->
      <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['total-price-bill__content']" [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'bo_goc' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['total-price-bill__content']"
                [textWrapperClass]="class['total-price-bill__wrapper']"
                [filterConfig]="config['filter']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['total-price-bill']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
          [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['total-price-bill']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['total-price-bill__content']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>